import React from "react"
import './skills.css'
export const Skills = () => {
  return (
    <div>
      <h3 className="skills-header">Software Skills</h3>
      <div className="tech-stack">
        <div className="stack-images">
          <img
            alt=""
            src="https://img.icons8.com/color/144/000000/javascript.png"
          />
          <p>JavaScript</p>
        </div>
        <div className="stack-images">
          <img
            alt=""
            src="https://img.icons8.com/color/144/000000/react-native.png"
          />
          <p>React</p>
        </div>

        <div className="stack-images">
          <img
            alt=""
            src="https://img.icons8.com/color/144/000000/bootstrap.png"
          />
          <p>Bootstrap</p>
        </div>
        <div className="stack-images">
          <img
            alt=""
            src="https://img.icons8.com/color/144/000000/material-ui.png"
          />
          <p>Material UI</p>
        </div>
        <div className="stack-images">
          <img
            alt=""
            src="https://img.icons8.com/color/144/000000/html-5.png"
          />
          <p>HTML5</p>
        </div>
        <div className="stack-images">
          <img alt="" src="https://img.icons8.com/color/144/000000/css3.png" />
          <p>CSS3</p>
        </div>
      </div>
    </div>
  )
}
